const U = (id) => `https://images.unsplash.com/photo-${id}?w=1600&q=80&auto=format&fit=crop`;

export const CONTACT = {
  phone: "+49 171 534 01 05",
  phoneHref: "tel:+491715340105",
  email: "info@freie-trauung-deluxe.de",
  region: "Krefeld",
  whatsapp: "https://wa.me/491715340105",
};

export const mailto = (subject) =>
  `mailto:${CONTACT.email}?subject=${encodeURIComponent(subject)}`;

export const IMAGES = {
  hero: "/images/hero.webp",
  archBlush: "/images/freie-trauung.webp",
  ringsGold: U("1606800052052-a08af7148866"),
  mark: "/images/mark-daviz-weg.webp",
  markAlt: "/images/mark-daviz.webp",
  angela: "/images/angela-puxi.webp",
  angelaAlt: "/images/angela-puxi-weg.webp",
  weddingBride: U("1778695941250-35c9b7959414"),
  chairsOutdoor: U("1522673607200-164d1b6ce486"),
  pathway: U("1500382017468-9049fed747ef"),
  weddingCouple: U("1519741497674-611481863552"),
  weddingHands: U("1465495976277-4387d4b0b4c6"),
  weddingAisle: "/images/hochzeitszeremonie.webp",
  weddingTable: U("1519225421980-715cb0215aed"),
  bride: U("1520854221256-17451cc331bf"),
  babyFeet: "/images/willkommensfeier.webp",
  familyHands: U("1511895426328-dc8714191300"),
  sunsetField: U("1470252649378-9c29740c9fa8"),
  restaurant: U("1414235077428-338989a2e8c0"),
  catering: U("1555244162-803834f70033"),
  flowers: U("1487530811176-3780de880c2d"),
  microphone: U("1511671782779-c97d3d27a1d4"),
  dj: U("1470229722913-7c0e2dbbafd3"),
  camera: U("1516035069371-29a1b244cc32"),
  eventHall: U("1519167758481-83f550bb49b3"),
  eventLights: U("1429962714451-bb934ecdc4ec"),
  eventTable: U("1502635385003-ee1e6a1a742d"),
  dinnerCandles: U("1511795409834-ef04bbd61622"),
};

export const NAV_LINKS = [
  { to: "/leistungen", label: "Leistungen" },
  { to: "/zeremonien", label: "Zeremonien" },
  { to: "/mark-daviz", label: "Mark Daviz" },
  { to: "/angela-puxi", label: "Angela Puxi" },
  { to: "/kosten", label: "Kosten" },
  { to: "/hoerbeispiele", label: "Hörbeispiele" },
];

export const SERVICES = [
  {
    title: "Persönliche Beratung",
    text: "Alles beginnt mit einem Gespräch. Wir hören zu, stellen Fragen und verstehen, worum es Ihnen wirklich geht – unverbindlich und ohne Zeitdruck.",
  },
  {
    title: "Ausführliches Kennenlernen",
    text: "Bei einem ausführlichen Kennenlerngespräch – bei Ihnen zu Hause, an Ihrem Lieblingsort oder per Video – lernen wir Ihre Geschichte kennen.",
  },
  {
    title: "Individuelle Reden",
    text: "Jede Rede schreiben wir von Grund auf neu. Aus Ihren Erzählungen entsteht eine Rede, die nur für diesen einen Moment geschrieben wurde.",
  },
  {
    title: "Ihr Lied – live performt",
    text: "Mark Daviz singt Ihren Song live zur Zeremonie, Angela Puxi spielt Ihr Lied live mit Saxophon zur Zeremonie. Auch kann der jeweils andere dazugebucht werden und komplettiert Ihre Feier zu einem unvergesslichen Moment. Kein Playback, keine Konserve – unser besonderes Extra: Ihre Geschichte und Ihr Lied, live.",
  },
  {
    title: "Vorbereitung & Planung",
    text: "Wir stimmen Ablauf, Musik und Rituale mit Ihnen ab und denken an alles, damit Sie am Tag Ihrer Zeremonie nichts mehr denken müssen.",
  },
  {
    title: "Persönliche Abstimmung",
    text: "Auf Wunsch sprechen wir mit Familie, Freunden oder Trauzeugen – oft verbergen sich gerade dort die schönsten Geschichten.",
  },
  {
    title: "Durchführung & Moderation",
    text: "Am Tag selbst führen wir ruhig und sicher durch Ihre Zeremonie. Präsent, aber nie im Vordergrund – der Moment gehört Ihnen.",
  },
  {
    title: "Rituale & Elemente",
    text: "Vom Kerzenritual bis zum Handfasting: Wir entwickeln gemeinsam mit Ihnen Elemente, die zu Ihnen passen – nicht umgekehrt.",
  },
  {
    title: "Beratung zu Musik & Ablauf",
    text: "Musik trägt Emotionen. Wir beraten Sie bei der Auswahl und verweben Musik und Worte zu einem stimmigen Ganzen.",
  },
  {
    title: "Netzwerk & Partner",
    text: "Locations, Catering, Floristik, Fotografie: Wir arbeiten mit Menschen zusammen, die wir kennen und denen wir vertrauen.",
  },
];

export const CEREMONIES = [
  {
    slug: "freie-trauung",
    title: "Freie Trauung",
    image: IMAGES.archBlush,
    teaser: "Eheversprechen ohne Konvention – eine Trauung, die so einzigartig ist wie Ihre Geschichte.",
    description:
      "Eine freie Trauung folgt keinem vorgegebenen Ritual. Sie entsteht aus Ihrer gemeinsamen Geschichte: wie Sie sich kennengelernt haben, was Sie verbindet, was Sie einander versprechen möchten. Mal leise und intim, mal ausgelassen und voller Lachen – immer echt.",
    forWhom: "Für Paare, die sich bewusst und persönlich das Ja-Wort geben möchten – unabhängig von Konvention, Konfession oder Standesamt.",
    role: "Mark oder Angela begleiten Sie vom ersten Gespräch bis zum Ja-Wort, schreiben Ihre Traurede und führen durch die Zeremonie.",
    ablauf: ["Kennenlerngespräch", "Paargespräch & Geschichten", "Individuelle Traurede", "Probe & Feinabstimmung", "Ihre Zeremonie"],
  },
  {
    slug: "hochzeitszeremonie",
    title: "Hochzeitszeremonie",
    image: IMAGES.weddingAisle,
    teaser: "Der schönste Tag verdient Worte, die bleiben – persönlich erzählt, würdevoll gefeiert.",
    description:
      "Ob im Grünen, in einer Scheune oder im Ballsaal: Ihre Hochzeitszeremonie wird zum emotionalen Mittelpunkt des Tages. Wir erzählen Ihre Liebesgeschichte so, dass Ihre Gäste lachen, weinen und staunen – oft alles gleichzeitig.",
    forWhom: "Für Paare, die ihre Hochzeit um einen unvergesslichen, emotionalen Höhepunkt bereichern möchten.",
    role: "Wir moderieren die Zeremonie, binden Familie und Freunde ein und stimmen uns eng mit Location und Dienstleistern ab.",
    ablauf: ["Erstes Gespräch", "Ihre Geschichte in Worte", "Musik & Rituale wählen", "Generalprobe", "Der große Moment"],
  },
  {
    slug: "willkommensfeier",
    title: "Willkommensfeier",
    image: IMAGES.babyFeet,
    teaser: "Ein neuer Mensch wird begrüßt – mit Worten, die von Herzen kommen.",
    description:
      "Eine Willkommensfeier ist ein Fest des Anfangs. Wir feiern die Ankunft Ihres Kindes, sprechen seinen Namen aus und erzählen, was seine Ankunft für Ihre Familie bedeutet. Ein Moment, der bleibt – für das Kind und für alle, die es lieben.",
    forWhom: "Für Familien, die die Geburt ihres Kindes auf persönliche, weltliche Weise feiern möchten.",
    role: "Wir gestalten eine warme, heitere Feier und binden Paten, Großeltern und Geschwister liebevoll ein.",
    ablauf: ["Familiengespräch", "Namen & Bedeutung", "Persönliche Rede", "Ritual des Willkommens", "Gemeinsames Feiern"],
  },
  {
    slug: "kinderwillkommensfest",
    title: "Kinderwillkommensfest",
    image: IMAGES.familyHands,
    teaser: "Groß und klein feiern gemeinsam – ein Fest für die ganze Familie.",
    description:
      "Das Kinderwillkommensfest ist die ausgelassene Schwester der Willkommensfeier: mehr Spiel, mehr Lachen, mehr Familie. Wir erzählen kleine Anekdoten, lassen Wünsche für das Kind aufschreiben und schaffen einen Anlass, an den sich alle gern erinnern.",
    forWhom: "Für Familien, die ein lebendiges Fest mit vielen Gästen, Paten und Freunden wünschen.",
    role: "Wir moderieren durch den Tag, halten die Rede und koordinieren auf Wunsch Musik und Beiträge der Gäste.",
    ablauf: ["Planung mit der Familie", "Beiträge der Paten", "Rede & Ritual", "Festakt", "Offenes Feiern"],
  },
  {
    slug: "eheversprechen",
    title: "Eheversprechen erneuern",
    image: IMAGES.ringsGold,
    teaser: "Nach Jahren noch einmal Ja sagen – bewusster, tiefer, reifer.",
    description:
      "Ein erneuertes Eheversprechen ist kein Blick zurück, sondern ein Versprechen nach vorn. Wir erzählen, was Sie gemeinsam durchgestanden und gefeiert haben – und formulieren mit Ihnen Worte für alles, was noch kommen soll.",
    forWhom: "Für Paare, die ihre Liebe nach Jahren bewusst erneuern möchten – im kleinen Kreis oder mit großem Fest.",
    role: "Wir schreiben Ihre gemeinsame Geschichte weiter und gestalten eine Zeremonie, die Ihre Jahre würdigt.",
    ablauf: ["Gespräch zu zweit", "Meilensteine & Geschichten", "Neue Versprechen", "Die Zeremonie", "Anstoßen & Feiern"],
  },
  {
    slug: "jubilaeumszeremonie",
    title: "Jubiläumszeremonie",
    image: IMAGES.dinnerCandles,
    teaser: "Ein Leben, eine Liebe, eine Firma – Meilensteine verdienen Worte.",
    description:
      "Ob Ehejubiläum, Firmenjubiläum oder runder Geburtstag: Wir verdichten Jahre zu einer Rede, die würdigt, ohne zu überhöhen. Mit Humor, mit Respekt und mit dem einen Satz, der hängen bleibt.",
    forWhom: "Für alle, die einen besonderen Meilenstein mit Würdigung und Wärme feiern möchten.",
    role: "Wir recherchieren, sprechen mit Wegbegleitern und halten eine Rede, die das Jubiläum trägt.",
    ablauf: ["Themenfindung", "Gespräche & Recherche", "Rede schreiben", "Feinabstimmung", "Der Festakt"],
  },
  {
    slug: "lebensfeier",
    title: "Lebensfeier",
    image: IMAGES.sunsetField,
    teaser: "Das Leben feiern – einfach, weil es es wert ist.",
    description:
      "Eine Lebensfeier kann ein Geburtstag sein, ein Neuanfang, ein bewusster Abschluss – oder einfach ein Fest ohne konkreten Anlass. Es gibt keinen Grund, der zu klein, und keine Idee, die zu ungewöhnlich ist.",
    forWhom: "Für alle, die einen persönlichen Wendepunkt oder Meilenstein würdigen möchten – jenseits aller Konventionen.",
    role: "Wir entwickeln mit Ihnen ein Format, das zu Ihrem Anlass passt – vom Festakt bis zur stillen Runde.",
    ablauf: ["Ihr Anlass im Gespräch", "Konzept entwickeln", "Worte & Rituale", "Die Feier", "Was bleibt"],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Zuhören vor Sprechen",
    text: "Bevor wir ein einziges Wort schreiben, hören wir zu. Ihre Geschichte ist das Material – wir geben ihr nur die Form.",
  },
  {
    no: "02",
    title: "Keine Zeremonie von der Stange",
    text: "Wir verwenden keine Vorlagen. Jede Rede wird für genau einen Menschen, genau ein Paar, genau einen Moment geschrieben.",
  },
  {
    no: "03",
    title: "Würde braucht Wahrheit",
    text: "Eine gute Zeremonie beschönigt nichts. Sie erzählt das Leben, wie es ist – und findet genau darin die Schönheit.",
  },
  {
    no: "04",
    title: "Persönlich bis zum letzten Satz",
    text: "Wir begleiten wenige Zeremonien, dafür ganz. Sie erreichen uns persönlich – vom ersten Anruf bis zum letzten Händedruck.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Mark hat unsere Geschichte so erzählt, als hätte er uns seit Jahren gekannt. Unsere Gäste sprechen bis heute von dieser Zeremonie.",
    name: "Lena & Jonas",
    context: "Freie Trauung, September",
  },
  {
    quote:
      "Nach 25 Jahren noch einmal Ja zu sagen war mutig – Angela hat aus unseren vielen kleinen Geschichten eine Zeremonie gemacht, bei der wir beide geweint haben.",
    name: "Sabine & Karl",
    context: "Eheversprechen erneuert, Juni",
  },
  {
    quote:
      "Wir wollten keine Show, wir wollten etwas Echtes. Genau das war es. Unsere Tochter wird diese Willkommensfeier eines Tages in Fotos sehen – und wir werden ihr jedes Wort davon erzählen können.",
    name: "Miriam & Thomas",
    context: "Willkommensfeier",
  },
];

export const AUDIO_SAMPLES = [
  {
    title: "„Halt mich“ – Ihr Lied, live gesungen",
    speaker: "Mark Daviz",
    duration: "3:12",
    description: "Ein Ausschnitt aus Marks Live-Gesang – so klingt Ihr Lied, wenn er es zu Ihrer Zeremonie singt.",
    src: "/audio/halt-mich.mp3",
  },
  {
    title: "Persönliche Vorstellung",
    speaker: "Mark Daviz",
    duration: "1:24",
    description: "Wer ich bin, warum ich Redner wurde – und was Sie von mir erwarten dürfen.",
  },
  {
    title: "Persönliche Vorstellung",
    speaker: "Angela Puxi",
    duration: "1:38",
    description: "Ein kurzer Einblick in meine Stimme, meine Haltung und meine Arbeit.",
  },
  {
    title: "Auszug einer Traurede",
    speaker: "Mark Daviz",
    duration: "3:12",
    description: "Wie eine Liebesgeschichte klingt, wenn sie für zwei Menschen geschrieben wurde.",
  },
  {
    title: "Auszug einer Traurede",
    speaker: "Angela Puxi",
    duration: "2:47",
    description: "Warm, persönlich und mit einem Lächeln – ein Ausschnitt aus einer echten Zeremonie.",
  },
  {
    title: "Eine Willkommensfeier",
    speaker: "Mark Daviz",
    duration: "2:21",
    description: "Heiter und herzlich – so klingt der Anfang eines neuen Lebens.",
  },
];

export const PRICING = [
  {
    name: "Trauung & Feier",
    price: "auf Anfrage",
    note: "Freie Trauungen, Hochzeiten, Eheversprechen",
    features: [
      "Ausführliches Kennenlerngespräch",
      "Individuell geschriebene Rede",
      "Persönliche Abstimmung aller Details",
      "Beratung zu Musik & Ritualen",
      "Durchführung der Zeremonie",
      "Probe am Vortag (auf Wunsch)",
    ],
    highlighted: true,
  },
  {
    name: "Willkommen & Familie",
    price: "auf Anfrage",
    note: "Willkommensfeiern & Kinderwillkommensfeste",
    features: [
      "Familiengespräch in Ruhe",
      "Persönliche Rede für Ihr Kind",
      "Ritual des Willkommens",
      "Einbindung von Paten & Familie",
      "Durchführung der Feier",
    ],
    highlighted: false,
  },
];

export const PRICING_INCLUDED = [
  "Alle Gespräche & Abstimmungen – so viele, wie es braucht",
  "Eine Rede, die nur für Sie geschrieben wurde",
  "Anfertigung und Feinschliff bis zur letzten Fassung",
  "Persönliche Erreichbarkeit während der gesamten Vorbereitung",
  "Durchführung und Moderation der Zeremonie",
];

export const PRICING_EXTRA = [
  { label: "Fahrtkosten", text: "Innerhalb von 50 km inklusive, darüber hinaus nach Aufwand – transparent in Ihrem Angebot ausgewiesen." },
  { label: "Besondere Rituale", text: "Materielle Elemente (z. B. Kerzen, Bänder) nach Absprache." },
  { label: "Technik & Ausstattung", text: "Mikrofon & Beschallung über unsere Partner, auf Wunsch organisieren wir alles." },
  { label: "Zusätzliche Termine", text: "Weitere Probe- oder Planungstermine nach Aufwand." },
];

export const PARTNERS = {
  locations: [
    {
      name: "Gut Lindenhof",
      ort: "Am Ortsrand",
      image: IMAGES.eventHall,
      description: "Historischer Gutshof mit Scheune und Park – für Feiern zwischen 20 und 200 Gästen.",
      besonderheiten: "Freie Trauung im Park möglich, Übernachtung für Gäste",
      link: "#",
    },
    {
      name: "Villa am See",
      ort: "Uferlage",
      image: IMAGES.chairsOutdoor,
      description: "Weiße Villa mit Terrasse direkt am Wasser. Besonders schön bei Sonnenuntergang.",
      besonderheiten: "Zeremonie am Steg, eigene Eventbetreuung",
      link: "#",
    },
    {
      name: "Waldgasthof Eiche",
      ort: "Im Grünen",
      image: IMAGES.restaurant,
      description: "Familiengeführter Gasthof am Waldrand – rustikal, herzlich und unkompliziert.",
      besonderheiten: "Kaminzimmer für kleine Zeremonien, regionale Küche",
      link: "#",
    },
  ],
  catering: [
    {
      name: "Feinkost & Feste",
      ort: "Regionweit",
      image: IMAGES.catering,
      description: "Vom Fingerfood-Empfang bis zum mehrgängigen Menu – ehrliche Küche mit regionalen Produkten.",
      besonderheiten: "Vegetarisch & vegan als Standard, kein Aufpreis",
      link: "#",
    },
    {
      name: "Tafelgold Catering",
      ort: "Stadt & Umland",
      image: IMAGES.eventTable,
      description: "Elegante Tafelkultur für festliche Anlässe – mit eigener Patisserie.",
      besonderheiten: "Hochzeitstorten nach eigenem Rezept",
      link: "#",
    },
  ],
  dienstleister: [
    {
      name: "Blumenwerkstatt Flora",
      kategorie: "Floristik",
      image: IMAGES.flowers,
      description: "Sträuße, Gestecke und Raumschmuck – mit Liebe zu Wildblumen und saisonalen Blüten.",
      link: "#",
    },
    {
      name: "Lichtblick Fotografie",
      kategorie: "Fotografie & Video",
      image: IMAGES.camera,
      description: "Unaufgeregte, dokumentarische Bilder. Keine gestellten Posen – echte Momente.",
      link: "#",
    },
    {
      name: "Ton & Licht Meyer",
      kategorie: "Veranstaltungstechnik",
      image: IMAGES.eventLights,
      description: "Dezente Beschallung und stimmungsvolles Licht – damit jedes Wort ankommt.",
      link: "#",
    },
    {
      name: "Duo Saitenklang",
      kategorie: "Musik",
      image: IMAGES.microphone,
      description: "Gitarre und Gesang für Zeremonien – von klassisch bis zeitgenössisch.",
      link: "#",
    },
    {
      name: "DJ Klangraum",
      kategorie: "Musik & Party",
      image: IMAGES.dj,
      description: "Vom Dinner-Sound bis zur ausgelassenen Feier – ein DJ, der zuerst zuhört.",
      link: "#",
    },
    {
      name: "Festlich Dekoriert",
      kategorie: "Dekoration",
      image: IMAGES.weddingTable,
      description: "Traubögen, Tischlandschaften und kleine Details, die große Wirkung haben.",
      link: "#",
    },
  ],
};

export const PEOPLE = {
  mark: {
    name: "Mark Daviz",
    role: "Freier Redner & Zeremonienleiter",
    image: IMAGES.mark,
    imagePos: "center 12%",
    imageAlt: IMAGES.markAlt,
    imageAltPos: "center 10%",
    quote: "„Die schönsten Reden entstehen nicht am Schreibtisch. Sie entstehen beim Zuhören.“",
    intro:
      "Ich bin Mark – und ich glaube, dass jeder Mensch eine Geschichte hat, die es verdient, gut erzählt zu werden. Seit über sieben Jahren begleite ich Menschen durch die großen Momente ihres Lebens: Ja-Worte, Anfänge und unvergessliche Feste.",
    bio: [
      "Schon früh wurde deutlich, dass Mark Daviz eine besondere Verbindung zur Bühne besitzt. Bereits im Alter von acht Jahren erhielt er Gesangsunterricht und entwickelte seine Stimme kontinuierlich weiter. Mit zwölf Jahren entdeckte er die Welt des Soul und Funk für sich – eine musikalische Begegnung, die seinen weiteren Weg entscheidend prägen sollte.",
      "Seine außergewöhnliche, über vier Oktaven reichende Stimme entwickelte einen unverwechselbaren Charakter: kraftvoll, rau, gefühlvoll und tief im Soul verwurzelt. Größen wie Joe Cocker, Liza Minnelli und Herbie Hancock wurden auf ihn aufmerksam; Mark stand im Vorprogramm internationaler Stars auf der Bühne und wirkte bei verschiedenen Studioarbeiten mit.",
      "Doch die vielen Jahre auf und hinter der Bühne haben ihn nicht nur musikalisch geprägt. Bei unzähligen Veranstaltungen und besonderen Momenten erlebte er die unterschiedlichsten Redner und Persönlichkeiten. Dabei entstand eine weitere Leidenschaft: Menschen nicht nur mit Musik, sondern auch mit Worten zu erreichen.",
      "Heute ist Mark Daviz auch als Freier Trauredner und Redner für besondere Anlässe tätig. Dabei verbindet er das, was ihn bereits als Sänger auszeichnet: Präsenz, Einfühlungsvermögen, Gefühl für den richtigen Moment und die Fähigkeit, eine Atmosphäre entstehen zu lassen, die Menschen erreicht.",
      "Bei Freien Trauungen erzählt er die Geschichte zweier Menschen persönlich, lebendig und mit der passenden Mischung aus Gefühl, Leichtigkeit und Humor. Denn ob gesungen oder gesprochen – für Mark Daviz geht es am Ende immer um dasselbe: Menschen zu berühren und einem besonderen Augenblick eine Stimme zu geben.",
    ],
    values: ["Wahrhaftigkeit vor Pathos", "Ruhe vor Effekt", "Zuhören vor Reden", "Nähe vor Routine"],
    skills: [
      "Traureden & freie Trauungen",
      "Live Gesang",
      "Moderation großer Feste",
      "Rituale & Zeremoniendesign",
    ],
    facts: [
      { q: "Kaffee oder Tee?", a: "Kaffee. Schwarz, am liebsten beim ersten Gespräch mit einem Paar." },
      { q: "Der schönste Ort für eine Trauung?", a: "Dort, wo das Paar eine Geschichte hat. Der Rest ist Dekoration." },
      { q: "Woran erkennt man eine gute Rede?", a: "Daran, dass jemand danach sagt: Genau so sind wir." },
      { q: "Wenn ich nicht schreibe …", a: "… bin ich mit dem Motorrad unterwegs oder lese Biografien von Menschen, die niemand mehr kennt." },
    ],
    cta: "Unverbindliches Gespräch mit Mark",
  },
  angela: {
    name: "Angela Puxi",
    role: "Freie Rednerin",
    image: IMAGES.angela,
    imagePos: "center 22%",
    imageAlt: IMAGES.angelaAlt,
    imageAltPos: "center 10%",
    quote: "„Eine gute Rede entsteht, wenn man einen Menschen wirklich ernst nimmt.“",
    intro:
      "Ich bin Angela. Ich habe gelernt, dass die richtigen Worte tragen können – in der Freude wie in den leisen Momenten. Deshalb schreibe ich Reden, die nicht geschönt sind, sondern ehrlich. Und genau deshalb berührend.",
    bio: [
      "Angela Puxi ist Musikerin, Saxophonistin und freie Rednerin mit sardischen Wurzeln. Seit vielen Jahren steht sie auf internationalen Bühnen und hat dabei eines gelernt: Entscheidend ist nicht, wie viele Töne oder Worte man verwendet – sondern was man damit erzählt.",
      "Als studierte Jazz-Saxophonistin führte sie ihr Weg durch ganz Europa, in die USA, nach China und Israel. Sie arbeitete mit internationalen Künstlern und Formationen wie YELLO und Alex Christensen, veröffentlichte eigene Alben und entwickelte mit der Angela Puxi Band und dem Angela Puxi Quartett ihren ganz persönlichen musikalischen Stil.",
      "Schon in ihrer Musik stand für Angela Puxi immer das Erzählen im Mittelpunkt. Nicht Effekthascherei oder Selbstdarstellung, sondern Authentizität, Persönlichkeit und die Verbindung zu den Menschen. Genau diese Haltung prägt heute auch ihre Arbeit als freie Rednerin.",
      "Angela Puxi möchte keine austauschbaren Reden halten. Sie möchte zuhören, verstehen und aus persönlichen Geschichten Worte entstehen lassen, in denen sich Menschen wirklich wiederfinden. Bei Freien Trauungen und besonderen Lebensmomenten verbindet sie ihre langjährige Bühnenerfahrung mit Empathie, Natürlichkeit und ihrem sardischen Temperament.",
      "Denn für Angela Puxi gilt beim Reden dasselbe wie in ihrer Musik: Es geht nicht darum, möglichst viel zu sagen. Es geht darum, etwas zu erzählen, das Menschen erreicht und in Erinnerung bleibt.",
    ],
    values: ["Ehrlichkeit vor Schönfärberei", "Wärme vor Distanz", "Gründlichkeit vor Tempo", "Mensch vor Ablauf"],
    skills: [
      "Freie Trauungen & Hochzeiten",
      "Saxophon live zur Zeremonie",
      "Eheversprechen & Jubiläen",
      "Einfühlsame Gesprächsführung",
    ],
    facts: [
      { q: "Ihr erster Gedanke vor jeder Zeremonie?", a: "Atmen. Zuhören. Und daran denken, dass dieser Tag für jemanden der wichtigste des Jahres ist." },
      { q: "Was macht eine Zeremonie unvergesslich?", a: "Ein Detail, das nur die Familie kennt – und das plötzlich alle verstehen." },
      { q: "Ihr liebstes Ritual?", a: "Der Moment nach der Rede, wenn niemand sofort applaudiert. Diese Stille ist ein Geschenk." },
      { q: "Wenn ich nicht schreibe …", a: "… gärtnere ich, backe Brot oder wandere – am liebsten dorthin, wo es kein Netz gibt." },
    ],
    cta: "Unverbindliches Gespräch mit Angela",
  },
};

export const BUSINESS_LD = (origin) => ({
  "@type": ["ProfessionalService", "LocalBusiness", "Organization"],
  "@id": `${origin}/#unternehmen`,
  name: "Freie Trauung Deluxe – Mark Daviz & Angela Puxi",
  alternateName: "Daviz & Puxi",
  description:
    "Freie Redner für individuelle Zeremonien: freie Trauungen, Hochzeiten, Willkommensfeiern, Eheversprechen und Jubiläen – mit Live-Musik aus Gesang und Saxophon.",
  url: origin,
  telephone: "+49 171 534 01 05",
  email: "info@freie-trauung-deluxe.de",
  image: `${origin}/images/hero.webp`,
  priceRange: "Auf Anfrage",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Pottbäckerstr. 17",
    postalCode: "47839",
    addressLocality: "Krefeld",
    addressRegion: "Nordrhein-Westfalen",
    addressCountry: "DE",
  },
  areaServed: [
    { "@type": "City", name: "Krefeld" },
    { "@type": "State", name: "Nordrhein-Westfalen" },
    { "@type": "Country", name: "Deutschland" },
  ],
  founder: [
    { "@type": "Person", name: "Mark Daviz", jobTitle: "Freier Trauredner & Sänger" },
    { "@type": "Person", name: "Angela Puxi", jobTitle: "Freie Rednerin & Saxophonistin" },
  ],
});

export const WEBSITE_LD = (origin) => ({
  "@type": "WebSite",
  "@id": `${origin}/#website`,
  url: origin,
  name: "Freie Trauung Deluxe – Daviz & Puxi",
  inLanguage: "de",
  publisher: { "@id": `${origin}/#unternehmen` },
});

export const SERVICE_LD = (origin) => ({
  "@type": "Service",
  name: "Freie Trauung",
  serviceType: "Freie Trauungszeremonie",
  description:
    "Individuelle freie Trauungen mit persönlich geschriebener Traurede – auf Wunsch mit Live-Gesang von Mark Daviz und Saxophon von Angela Puxi.",
  provider: { "@id": `${origin}/#unternehmen` },
  areaServed: [
    { "@type": "City", name: "Krefeld" },
    { "@type": "State", name: "Nordrhein-Westfalen" },
  ],
});

export const FAQ_LD = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const PERSON_LD = (origin, { name, jobTitle, image, path }) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  name,
  jobTitle,
  image: `${origin}${image}`,
  url: `${origin}${path}`,
  worksFor: { "@type": "ProfessionalService", name: "Freie Trauung Deluxe", url: origin },
});
